module.exports = __webpack_public_path__ + "static/img/2023_9_8_6.3e8ad768.3e8ad76.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/2023_9_8_6.3e8ad768.png
// module id = cKXB
// module chunks = 0